import React from 'react';
import styled from 'styled-components';
import FreeBreakfastIconSvg from '../../assets/hotels/amenities/freeBreakfast.svg';

const FreeBreakfastIcon = styled(FreeBreakfastIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  /* fill: ${props => props.fill || props.theme.colors.downriver.medium}; */
  fill: ${props => props.fill || props.theme.colors.goGreen.base};
  margin: ${props => props.margin};
  cursor: pointer;
  g {
    path:last-child {
      // fill: ${props => props.fill || props.theme.colors.downriver.medium};
      fill: ${props => props.fill};
    }
  }
`;

export default FreeBreakfastIcon;
